import { connect } from 'react-redux';
import Notification from 'pages/NotificationNew';
import homePageNewActions from 'store/homePageNew/actions';
import newOlsActions from 'store/newOls/actions';

const mapStateToProps = state => {
  return {
    notification: state.homePageNew.notification,
    updatedNotification: state.homePageNew.updatedNotification,
    loadNotificationIsRequesting: state.homePageNew.loadNotificationIsRequesting,
    updateNotificationIsRequesting: state.homePageNew.updateNotificationIsRequesting,
  };
};
const mapDispatchToProps = {
  loadNotification: homePageNewActions.Creators.loadNotificationRequest,
  updateNotification: homePageNewActions.Creators.updateNotificationRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
